import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommMoonStarsIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M15.5 2.25C15.9142 2.25 16.25 2.58579 16.25 3V3.75H17C17.4142 3.75 17.75 4.08579 17.75 4.5C17.75 4.91421 17.4142 5.25 17 5.25H16.25V6C16.25 6.41421 15.9142 6.75 15.5 6.75C15.0858 6.75 14.75 6.41421 14.75 6V5.25H14C13.5858 5.25 13.25 4.91421 13.25 4.5C13.25 4.08579 13.5858 3.75 14 3.75H14.75V3C14.75 2.58579 15.0858 2.25 15.5 2.25ZM11.9559 2.63967C12.1019 2.88276 12.0983 3.18741 11.9466 3.427C11.1888 4.62407 10.75 6.04272 10.75 7.56616C10.75 11.8464 14.2198 15.3162 18.5 15.3162C19.0017 15.3162 19.4915 15.2686 19.9655 15.1779C20.244 15.1247 20.5287 15.233 20.7013 15.458C20.874 15.6829 20.905 15.986 20.7815 16.2412C19.205 19.4999 15.866 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12C2.25 6.86531 6.21868 2.65826 11.2565 2.27797C11.5392 2.25662 11.8099 2.39658 11.9559 2.63967ZM9.96112 4.00375C6.39111 4.91117 3.75 8.14743 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C14.7588 20.25 17.2024 18.8959 18.7007 16.814C18.634 16.8154 18.5671 16.8162 18.5 16.8162C13.3914 16.8162 9.25 12.6748 9.25 7.56616C9.25 6.30442 9.50299 5.10066 9.96112 4.00375ZM18.5 6.72363C18.9142 6.72363 19.25 7.05942 19.25 7.47363V9.22363H21C21.4142 9.22363 21.75 9.55942 21.75 9.97363C21.75 10.3878 21.4142 10.7236 21 10.7236H19.25V12.4736C19.25 12.8878 18.9142 13.2236 18.5 13.2236C18.0858 13.2236 17.75 12.8878 17.75 12.4736V10.7236H16C15.5858 10.7236 15.25 10.3878 15.25 9.97363C15.25 9.55942 15.5858 9.22363 16 9.22363H17.75V7.47363C17.75 7.05942 18.0858 6.72363 18.5 6.72363Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
